import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetScheduleProductionOrders = createModule({
  base: 'GET_SCHEDULE_PRODUCTION_ORDER',
  apiDetails: SERVICE_ENDPOINT.GET_SCHEDULE_PRODUCTION_ORDER,
  errors: { defaultError: false, customError: '' },
});

export { GetScheduleProductionOrders };